const config = {
  apiBaseUrl: 'https://backend.aromaagrotech.com/api',
  apiBaseUrl1: 'https://backend.aromaagrotech.com/api',
  // apiBaseUrl:"http://localhost:2026/api",
  // apiBaseUrl1:"http://localhost:2026/api",


  // market-report
  reportDateAvilable: 'market-survey/report-date-available',
};

export default config;

